
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardYearOverviewPerMonthData } from "@/utils/dashboard/dashboard-year-overview-per-month-data";
import { getModel, Model } from "@/utils/models/model";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import AppHumanFilterListEdit from "@/components/models/HumanFilterListEdit.vue";

export default Vue.extend({
	data(){
		return {
			saleBrowse: undefined as undefined | Browse,
			purchaseBrowse: undefined as undefined | Browse,
			data: new DashboardYearOverviewPerMonthData(),
			tab: 0,
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		saleModel():Model | undefined{
			if (!this.saleBrowse) return undefined;
			return getModel(this.saleBrowse.Table);
		},
		purchaseModel():Model | undefined {
			if (!this.purchaseBrowse) return undefined;
			return getModel(this.purchaseBrowse.Table);
		},
		tabs():string[] {
			return [
				this.$ct("common.general"),
				this.$ct("income-filters"),
				this.$ct("cost-filters")
			].map(i=>i.toString());
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data) {
					this.data = new DashboardYearOverviewPerMonthData();
					return;
				}
				this.data = new DashboardYearOverviewPerMonthData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
	},
	async created() {
		this.saleBrowse = BrowseService.browses.find(b=>b.ID == 6);
		this.purchaseBrowse = BrowseService.browses.find(b=>b.ID == 6);
	},
	components: {
		AppSelectBookYear,
		AppHumanFilterListEdit
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
